import MediaText from './MediaText'

export default MediaText
